export const alerts = {
  title: 'Alerts',
  noReadingReminderMessage: 'No Reading Reminder Texts are sent at 11 AM (Eastern Time) every day.',
  dateRange: {
    allTime: 'All Time',
    thisMonth: 'This Month'
  },
  tabs: {
    patients: 'Patients',
    reports: 'Reports'
  },
  actions: {
    markAsRead: 'Mark as Read',
    markAsUnread: 'Mark as Unread',
    archive: 'Archive'
  },
  dialogs: {
    archiveTitle: 'Archive RPM Alerts'
  },
  kpiWidget: {
    hint: 'Click icon to see the corresponding alert(s)',
    all: 'All',
    viewAll: (count: number) => `View all ${count} alerts`
  },
  typeFilter: {
    allSelected: 'All alert types selected',
    partial: 'Showing:',
    selectAll: 'Select all',
    reset: 'Reset',
    resetTooltip: 'Show every alert type again',
    allTooltip: 'Click to show every alert type'
  },
  grid: {
    openAlert: 'Click for alert',
    info: 'Info',
    alert: 'Alert',
    patientName: 'Patient Name',
    phoneNumber: 'Phone Number',
    description: 'Description',
    type: 'Type',
    reading: 'Reading',
    readStatus: 'Read Status',
    recordedAt: 'Recorded At',
    reminderSentAt: 'Reminder Sent At',
    lastReadingDate: 'Last Reading Date'
  },
  tooltips: {
    review: 'Review',
    patientInfo: 'Patient info',
    updateActivityManually: 'Please update the medication regimen activity manually as it cannot be found automatically.'
  },
  snackbars: {
    updatedSuccessfully: 'RPM Alert(s) Updated Successfully.',
    couldNotUpdate: 'Could not update RPM Alert(s).',
    couldNotRetrieve: 'Could not retrieve RPM Alert(s).',
    unableToRetrievePatientData: 'Unable to retrieve patient data',
    updateActivityManually: 'Please update the medication regimen activity manually as it cannot be found automatically.'
  }
} as const;
